<template>
  <div v-if="visible" class="outer-carousel">
    <Transition name="pop" appear>
      <div v-if="visible" class="modal" role="dialog">
        <div class="modal-overlay">
          <div class="card-carousel">
            <div class="card-img">
              <img :src="currentImage" alt="" />
              <div v-show="displayControls" class="actions">
                <template v-if="images.length > 1">
                  <span class="prev" @click="prevImage"> &#8249; </span>
                  <span class="next" @click="nextImage"> &#8250; </span>
                </template>
              </div>
            </div>
            <button v-show="displayControls" class="btn-close-modal" @click="closeModal">X</button>
            <div v-if="activeThumbnails" class="thumbnails">
              <div
                v-for="(image, index) in images"
                :key="index"
                :class="['thumbnail-image', focusedPosition === index ? 'active' : '']"
                @click="activateImage(index)"
              >
                <img :src="image" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
export default {
  name: 'rfp-ratings-list-carousel-modal',
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    mainPosition: {
      type: Number,
      required: false,
      default: 0,
    },
    images: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    showThumbnails: {
      type: Boolean,
      required: false,
      default: false,
    },
    showActions: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      focusedPosition: this.mainPosition,
      displayControls: this.showActions,
    };
  },
  computed: {
    currentImage() {
      return this.images[this.focusedPosition];
    },
  },
  watch: {
    mainPosition(n) {
      this.activateImage(n);
    },
  },
  created() {
    this.focusedPosition = this.mainPosition;
  },
  methods: {
    nextImage() {
      this.focusedPosition + 1 >= this.images.length
        ? (this.focusedPosition = 0)
        : (this.focusedPosition += 1);
    },
    prevImage() {
      this.focusedPosition - 1 < 0
        ? (this.focusedPosition = this.images.length - 1)
        : (this.focusedPosition -= 1);
    },
    activateImage(e) {
      this.focusedPosition = e;
    },
    closeModal() {
      this.$emit('closedmodal');
    },
  },
};
</script>
